export enum B2bPresumedDeliveryInterval {
	OnceOrTwiceAMonth = "OnceOrTwiceAMonth",
	OnceAWeek = "OnceAWeek",
	TwiceOrThreeTimesAWeek = "TwiceOrThreeTimesAWeek",
}

export const b2bCustomerPresumedDeliveryIntervalNameMap: Record<B2bPresumedDeliveryInterval, string> = {
	[B2bPresumedDeliveryInterval.OnceOrTwiceAMonth]: "1×–2× měsíčně",
	[B2bPresumedDeliveryInterval.OnceAWeek]: "1× týdně",
	[B2bPresumedDeliveryInterval.TwiceOrThreeTimesAWeek]: "2×–3× týdně",
};
